$(function () {
    if ($("div#EnrolmentPlanningDiv").length > 0) {

        //$.urlParam = function (name) {
        //    var results = new RegExp('[\?&]' + name + '=([^&#]*)')
        //        .exec(window.location.search);

        //    return (results !== null) ? results[1] || 0 : false;
        //}

        //var ddval = $.urlParam('pagesize');
        //$('#rowsSelect option[value="' + ddval + '"]').prop('selected', true);
        //var ddval2 = $.urlParam('pgSzP');
        //$('#rowsSelectp option[value="' + ddval2 + '"]').prop('selected', true);


        $('#ViewAsOfDate').datetimepicker('options', {
            format: "YYYY-MM-DD",
            locale: jsLang + '-ca',
            keepOpen: false,
            defaultDate: false
        });

        $('#ViewAsOfDate').keydown(function (e) {
            e.preventDefault();
        });

        $('#ViewAsOfDate').on('change.datetimepicker', function (e) {
            navigate(jsPrefix, jsLang);
        });

        $('#selectedlicense').on('change', function () {

            navigate(jsPrefix, jsLang);
        });

        function navigate(prefix, lang) {

            var test = $('#ViewAsOfDate').val();

            var selectedLicense = $('#selectedlicense').val();

            if (prefix != "q") {
                x = prefix + "/" + lang + "/" + 'license/manageenrolment/enrolmentplanning/' + jsOper + '/' + selectedLicense + "?"
                    + "viewasofdate=" + $('#ViewAsOfDate').val();
            }
            else {

                x = "/" + lang + "/" + 'license/manageenrolment/enrolmentplanning/' + jsOper + '/' + selectedLicense + "?"
                    + "viewasofdate=" + $('#ViewAsOfDate').val();
            }

            location.href = x;
            //Perform your navigation
        }

    }
});